function getNomeSobrenome(nomeCompleto) {
  if (nomeCompleto) {
    return nomeCompleto.replace(' DA ', ' ').replace(' DAS ', ' ').replace(' DE ', ' ')
      .replace(' DO ', ' ')
      .replace(' DOS ', ' ')
      .split(' ')
      .slice(0, 2)
      .join(' ');
  }
  return 'N/D';
}

export { getNomeSobrenome };
